import React, { useState, useEffect } from 'react'
import {
  Flex,
  MainHeadline,
  Tabs,
  TabsContainer,
  PageFooter,
  PageWrapper,
  Button,
  ContentWrapper,
} from '../../styling/GlobalStyles'
import { NavBar } from '../../components/NavBar/NavBar'
import { useNavigate } from 'react-router-dom'
import { clearShiftsList, getShifts } from 'features/shifts/shiftsSlice'
import { useDispatch, useSelector } from 'react-redux'
import { convertToDate, getParams, getUtcMonthRange, getWeekRangeUTC, handlePagination } from 'utils/helpers'
import { AppDispatch, RootState } from 'store'
import { Pagination } from 'components/Pagination/Pagination'
import { HonestSelectAsyncInput } from 'components/HonestAsyncSelect/HonestAsyncSelectInput'
import { ISelectValue } from 'constants/globalTypes'
import { ScheduleWeeklyDisplay } from './ScheduleWeeklyDisplay'
import { ScheduleMonthlyDisplay } from './ScheduleMonthlyDisplay'
import { endOfWeek, startOfWeek, } from 'date-fns'
import { HonestSelectInput } from 'components/HonestSelect/HonestSelectInput'
import { monthsOptions } from 'pages/Attendance/data'
import CalendarInput from 'components/CalendarInput/CalendarInput'
import { AiShiftsWrapper, ScheduleNavigation } from './Shifts.styled'
import { ScheduleAiAssistant } from './ScheduleAiAssistant'
import { FilterEnum, LinkEnum } from 'components/Filter/SingleFilter'

export const Schedule = () => {
  const [active, setActive] = useState('weekly')
  const { workSchedules, totalPages } = useSelector((store: RootState) => store.workSchedules)
  const dispatch = useDispatch<AppDispatch>()
  const navigate = useNavigate()
  const [params, setParams] = useState<any>(getParams({ location, ap: { dateFrom: getWeekRangeUTC(new Date()).start, dateTo: getWeekRangeUTC(new Date()).end } }))

  const handleSwitchActive = (a: string) => {
    setActive(a)
    if (a == 'weekly') {
      setParams((prev) => {
        const copy = { ...prev }
        copy.dateFrom = convertToDate(startOfWeek(new Date(), { weekStartsOn: 1 }))
        copy.dateTo = convertToDate(endOfWeek(new Date(), { weekStartsOn: 1 }))
        copy.page = 1
        copy.limit = 30
        return copy
      })
    } else {
      setParams(prev => ({ ...prev, page: 1, ...getUtcMonthRange(new Date().getMonth()) }))
    }
  }


  useEffect(() => {
    dispatch(getShifts({ page: 1, limit: 99 }))
    return () => {
      dispatch(clearShiftsList())
    }
  }, [])



  const handleWeekPick = (from: Date, to: Date) => {
    setParams((prev) => {
      const copy = { ...prev }
      copy.dateFrom = convertToDate(from)
      copy.dateTo = convertToDate(to)
      copy.page = 1
      copy.limit = 30
      return copy
    })
  }


  const handleSelect = (value: ISelectValue) => {
    setParams((prev) => {
      const copy = { ...prev }
      copy.roleId = value.value
      return copy
    })
  }

  const parseRoles = (data: any) => {
    return data.data.map((item: any) => ({ label: item.name, value: item.id }))
  }


  const handleMonth = (m: ISelectValue) => {
    setParams(prev => ({ ...prev, page: 1, ...getUtcMonthRange(m.value) }))
  }

  const filters = [
    {
      type: FilterEnum.SELECT,
      name: 'Status',
      options: [{ value: 1, label: 'Company' }, { value: 2, label: 'Contractors' }],
      propName: 'filterType'
    },
    {
      type: FilterEnum.SEARCH,
      link: LinkEnum.DEPARTMENTS,
      name: 'Departments',
      state: null,
    },
  ]

  return (
    <>
      <NavBar enableTemporaryManualClosing={true} filterOptions={filters} defaultValue={params.employeeName} input placeholder='Search Shifts...' setParams={setParams} limit={30} />
      <PageWrapper >
        <Flex center between mb='16' >
          <MainHeadline>Schedule</MainHeadline>
          <Flex gap='1rem' >
            <Button orange onClick={() => navigate('/hr/schedule/shifts')}>
              Manage Shifts
            </Button>
          </Flex>
        </Flex>
        <ScheduleNavigation  >
          <TabsContainer style={{ marginRight: 0, alignSelf: 'flex-end' }} mediaQShifts>
            <Tabs active={active === 'weekly'} onClick={() => handleSwitchActive('weekly')}>Weekly</Tabs>
            <Tabs active={active === 'monthly'} onClick={() => handleSwitchActive('monthly')}>Monthly</Tabs>
          </TabsContainer>
          <Flex width='100%' gap='1rem' justcenter end='true' alignEnd style={{ paddingBottom: '1rem' }} >
            <HonestSelectAsyncInput
              link='roles'
              placeholder='Search role'
              name='roleId'
              labelText='Role'
              // defaultValue={state?.role?.name}
              onChange={(value: ISelectValue) => handleSelect(value)}
              parserFunction={parseRoles}
              width='300px'
              nomarg
            />
            {active == 'weekly' ? <CalendarInput nomarg width='300px' week defaultValue={[params.dateFrom, params.dateTo]} onChange={handleWeekPick} /> : <HonestSelectInput width='300px' options={monthsOptions} defaultValue={new Date().getMonth()} onChange={handleMonth} labelText='' nomarg name='month' />}

          </Flex>
        </ScheduleNavigation>

        <ContentWrapper minus='16rem' noPadding>
          {active === 'weekly' ?
            <ScheduleWeeklyDisplay params={params} workSchedules={workSchedules} /> :
            <ScheduleMonthlyDisplay params={params} workSchedules={workSchedules} />}
        </ContentWrapper>
      </PageWrapper>
      <PageFooter  >

        <AiShiftsWrapper>
          <ScheduleAiAssistant params={params} />
        </AiShiftsWrapper>
        <Pagination
          setPage={(page) => handlePagination(page, setParams, 30)}
          pageCount={Math.ceil(totalPages)}
          forcePage={(params.page ? params.page : 1) - 1}
        />
      </PageFooter>
    </>
  )
}
